import { Alert, Card, Layout, Spin, Typography } from "antd";
import { useEffect, useState, type FC } from "react";
import { useSearchParams } from "react-router";

const { Text, Title } = Typography;

interface WpCredentials {
  password: string;
  user_login: string;
}

export const WpCallback: FC = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<"loading" | "success" | "error">("loading");
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const password = searchParams.get("password");
    const userLogin = searchParams.get("user_login");
    const cancelled = searchParams.get("cancelled");

    if (cancelled === "1") {
      setStatus("error");
      setError("Authorization was cancelled.");
      return;
    }

    if (!password || !userLogin) {
      setStatus("error");
      setError("Missing credentials in callback.");
      return;
    }

    // Verify we have a parent window to post to
    if (!window.opener || window.opener.closed) {
      setStatus("error");
      setError("This page must be opened from the Loopress console.");
      return;
    }

    // Send credentials to parent window
    window.opener.postMessage(
      {
        type: "wp-auth-success",
        credentials: {
          password,
          userLogin,
        },
      },
      window.origin
    );

    setStatus("success");
  }, [searchParams]);

  return (
    <Layout
      style={{
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "#f5f5f5",
      }}
    >
      <Card style={{ width: 400, textAlign: "center" }}>
        {status === "loading" && (
          <div>
            <Spin size="large" style={{ marginBottom: 16 }} />
            <Title level={4}>Processing authorization...</Title>
            <Text type="secondary">Please wait while we save your credentials.</Text>
          </div>
        )}

        {status === "success" && (
          <div>
            <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>✓</div>
            <Title level={4} style={{ color: "#15803d", marginBottom: "0.5rem" }}>
              Authorization successful!
            </Title>
            <Text type="secondary">
              Your WordPress credentials have been saved. You can close this tab.
            </Text>
          </div>
        )}

        {status === "error" && (
          <div>
            <div style={{ fontSize: "3rem", marginBottom: "1rem" }}>✗</div>
            <Title level={4} style={{ color: "#b91c1c", marginBottom: "0.5rem" }}>
              Authorization failed
            </Title>
            <Alert type="error" message={error} showIcon />
          </div>
        )}
      </Card>
    </Layout>
  );
};
